/**
 * @generated SignedSource<<81a33c03a3cc84eeaaaaa855254ec7e5>>
 * @relayHash b97bcc9fe8ba3d8ec44f4446d67b14fe
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID b97bcc9fe8ba3d8ec44f4446d67b14fe

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "CommercialCode",
    "kind": "LinkedField",
    "name": "commercialCodes",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSearchCommercialCodesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchCommercialCodesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b97bcc9fe8ba3d8ec44f4446d67b14fe",
    "metadata": {},
    "name": "useSearchCommercialCodesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "973396312aa412e30bcc9c48aa47ad79";

export default node;
